module.exports = __webpack_public_path__ + "img/brand-16.046af096.png";